import React, { Fragment } from "react";
import { MainAbout } from "../components/About/MainAbout";
import { PageHero } from "../components/Global/PageHero";
import { Member } from "../components/Home/Member";
import { BackToTop } from "../templates/BackToTop";

export const About = () => {
  return (
    <Fragment>
      <PageHero
        eyebrow="Who We Are"
        title="About"
        highlight="Us"
        subtitle="Let us give you a walk-through of this unique church."
      />
      <MainAbout />

      <Member />
      <BackToTop />
    </Fragment>
  );
};
